import React, { Component } from "react";
import { Link } from 'react-router-dom';
import Image from '../global/Image';

export default class PageInformation extends Component {
  	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div id={block.id} className={'c-page__block c-page__block--mobile-section c-page__block--text-space c-page__block--top-' + block.top_space + ' c-page__block--bottom-' + block.bottom_space + ' scope-' + block.background_colour}>
			    			    		
		    		<div className="c-page__block__inner">
		    				    			
 						<div className="c-information">
						
							<div className="c-information__column c-information__column--left">
								{block.icon == 'square' &&
									<h3 className="c-information__heading c-information__heading--mobile" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 4 4"><rect width="4" height="4"/></svg><span>' + block.heading + '</span>'}}></h3>
								}
								
								{block.icon == 'circle' &&
									<h3 className="c-information__heading c-information__heading--mobile" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 4 4"><circle cx="2" cy="2" r="2"/></svg><span>' + block.heading + '</span>'}}></h3>
								}
								
								{block.icon == 'hexagon' &&
									<h3 className="c-information__heading c-information__heading--mobile" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 4 4"><polygon style="fill:#FFFFFF;" points="3,0.3 1,0.3 0,2 1,3.7 3,3.7 4,2 "/></svg><span>' + block.heading + '</span>'}}></h3>
								}
		    					{block.src &&
		    						<div className="c-information__image">
		    							<Image src={block.src} srcset={block.srcset} />
		    						</div>
		    					}
		    				</div>
		    			
		    				<div className="c-information__column c-information__column--right">
		    					<div>
		    						{block.icon == 'square' &&
										<h3 className="c-information__heading c-information__heading--desktop" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 4 4"><rect width="4" height="4"/></svg><span>' + block.heading + '</span>'}}></h3>
									}
									
									{block.icon == 'circle' &&
										<h3 className="c-information__heading c-information__heading--desktop" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 4 4"><circle cx="2" cy="2" r="2"/></svg><span>' + block.heading + '</span>'}}></h3>
									}
									
									{block.icon == 'hexagon' &&
										<h3 className="c-information__heading c-information__heading--desktop" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 4 4"><polygon style="fill:#FFFFFF;" points="3,0.3 1,0.3 0,2 1,3.7 3,3.7 4,2 "/></svg><span>' + block.heading + '</span>'}}></h3>
									}
		    						<div className="scope-text scope-text--small scope-text--faded" dangerouslySetInnerHTML={{__html:block.text}}></div>
		    					</div>
		    					{block.button_text && block.button_url &&
			    					<div className="c-buttons c-buttons--left">
			    						{block.button_url.indexOf('http') === -1 &&
				    						<Link to={{ pathname: block.button_url }} className="c-buttons__button c-buttons__button--solid"	dangerouslySetInnerHTML={{__html:block.button_text}}></Link>
			    						}
			    						{block.button_url.indexOf('http') !== -1 &&
				    						<a href={block.button_url} className="c-buttons__button c-buttons__button--solid" target="_blank" dangerouslySetInnerHTML={{__html:block.button_text}}></a>
			    						}
			    					</div>
		    					}
		    				</div>
		    			
		    			</div>
																    			
		    		</div>
			    					    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
